<template>
  <div class="third others-manage_basic">
    <div class="third-rea">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="search">查询</el-button>
          <el-button class="btn-two" type="default" @click="Reset">重置</el-button>
          <span class="btn-shu"></span>
          <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
        </div>
      </div>
      <div class="third-search">
        <el-form :model="shieldManageInfo" ref="shieldManageInfo" :inline="true" label-width="76px">
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="公众号名称" prop="nickname">
                <el-input
                  class="item-input"
                  v-model="shieldManageInfo.nickname"
                  :maxlength="30"
                  placeholder="请输入"
                  @keyup.enter.native="search"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="账号" prop="keyId">
                <el-input
                  class="item-input"
                  v-model="shieldManageInfo.keyId"
                  :maxlength="30"
                  placeholder="请输入"
                  @keyup.enter.native="search"
                ></el-input>
              </el-form-item>
            </div>
            <!-- <div class="row-item">
              <el-form-item label="账号类型" prop="actionType">
                <el-select
                  class="item-input"
                  v-model="shieldManageInfo.actionType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in leixin_select_data"
                    :key="item.id"
                    :value="item.id"
                    :label="item.typeName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div> -->
            <div class="row-item">
              <el-form-item label="屏蔽类型" prop="actionType">
                <el-select
                  class="item-input"
                  v-model="shieldManageInfo.actionType"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in leixin_select_data"
                    :key="item.id"
                    :value="item.id"
                    :label="item.typeName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="内容" prop="content">
                <el-input
                  class="item-input"
                  v-model="shieldManageInfo.content"
                  :maxlength="30"
                  placeholder="请输入"
                  @keyup.enter.native="search"
                ></el-input>
              </el-form-item>
            </div>
            <!-- <div class="row-item">
              <el-form-item label="所属校区" prop="region">
                <el-select class="item-input" v-model="shieldManageInfo.region" placeholder="请选择">
                  <el-option
                    v-for="item in xiaoqu_select_data"
                    :key="item.dictKey"
                    :value="item.dictKey"
                    :label="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div> -->
            <div class="row-item">
              <el-form-item label="发布时间" prop="createTime">
                <el-date-picker
                  style="width:216px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  unlink-panels
                  v-model="shieldManageInfo.createTime"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  @change="changeCreateTime" 
                ></el-date-picker>
              </el-form-item>
            </div>
            <!-- <div class="row-item">
              <el-form-item label="屏蔽时间" prop="shieldTime">
                <el-date-picker
                  style="width:216px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  unlink-panels
                  v-model="shieldManageInfo.shieldTime"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                ></el-date-picker>
              </el-form-item>
            </div> -->
            <div class="row-item">
              <el-form-item label="屏蔽原因" prop="shieldContent">
                <!-- <el-input
                  class="item-input"
                  v-model="shieldManageInfo.shieldContent"
                  :maxlength="30"
                  placeholder="请输入"
                ></el-input>-->
                <el-select
                  class="item-input"
                  v-model="shieldManageInfo.shieldContent"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item,index) in getselectdata"
                    :key="index"
                    :value="item.id"
                    :label="item.content"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="屏蔽时间" prop="shieldTime">
                <el-date-picker
                  style="width:216px"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  unlink-panels
                  v-model="shieldManageInfo.shieldTime"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  @change="changeShieldTime" 
                ></el-date-picker>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one publicReport-btn-left">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button
            class="do-btn-four"
            type="default"
            icon="sp iconjinjilianxiren1"
            @click="Relieve(null)"
          >解除屏蔽</el-button>·
        </div>
        <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="otherSortOrignalData"
              sessionResultName="ShieldingManagement"
            ></sort-data>
            <display-field
              :selectList="tableRow"
              sessionOriginalName="otherDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="ShieldingManagementChange"
            ></display-field>
          </div>
        </div>
        <el-button
          class="do-btn-two"
          type="default"
          icon="sp iconpingbi"
          @click="ShieldingManagement"
        >自动屏蔽策略</el-button>
      </div>

      <template>
        <el-table
          class="third-tableThree ShieldingManagementIndex"
          :data="tableData"
          border
          stripe
          ref="ShieldingManagementIndex"
          :row-key="getRowKey"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="32px" :reserve-selection="true"></el-table-column>
          <template v-for="(val, key) in tableDataShow">
            <el-table-column
              v-if="val.needKeyValue"
              min-width="100px"
              :prop="val.key"
              :label="val.column"
              :key="key"
              style="color:red"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <!-- <key-value-span
                  :value="scope.row[val.key]"
                  :dictUrl="val.actionUrl"
                  @click="clickFN"
                ></key-value-span>-->
                <template v-if="val.key === 'managerName'">
                  <span>{{scope.row[val.key]}}（{{scope.row['managerAccount']}}）</span>
                </template>
                <el-button
                  v-else
                  @click="clickFN(scope.row)"
                  type="text"
                  size="small"
                >{{ scope.row[val.key] }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              min-width="100px"
              :prop="val.key"
              :label="val.column"
              :key="key"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </template>

          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="details(scope.row)">详情</el-button>
              <span class="table-middle_line"></span>
              <el-button type="text" size="small" @click="Relieve(scope.row)">解除屏蔽</el-button>
              <!-- <el-button type="text" size="small">屏蔽</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="third-page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </template>
    </div>
    <new-notice-modal
      :noticeModalVisible="noticeModal_danshan"
      :noticeTitle="noticeTitle_danshan"
      :noticeType="noticeType_danshan"
      :noticeContent="noitceContent_danshan"
      :noticeSpec="noticeSpec_danshan"
    >
      <template v-slot:footer>
        <template>
          <el-button class="modal-footer-two" @click="noticeModal_danshan = false">取消</el-button>
          <el-button class="modal-footer-two" type="primary" @click="Relieve_FN">确定</el-button>
        </template>
      </template>
    </new-notice-modal>
    <hign-modal
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="tableRow"
    ></hign-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { setStore, getStore } from "@/utils/store";
import { cloneDeep } from "lodash";
import {
  list,
  getActionTypeList,
  selectCampusNameAndId,
  shield,
  getReportReasonList
} from "@/store/mymethod/ShieldingManagement"; //我的
// import { eduotheruserinfoRemovePort } from "@/api/c1.2/other.js";
export default {
  name: "ShieldingManagementIndex",
  data () {
    return {
      loading: false,
      checkID: "",
      isIndeterminate: true,
      outputModal: false, // 导出弹窗
      isJS: true, //是否有检索条件
      rulesOutPut: {
        jbDesc: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      ruleFormOutPut: {
        checkAll: false, // 全选
        jbDesc: "学生基础数据201908021223",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      detailModal: false, // 详情弹窗
      isError: true, // 是否是错误提示
      noticeSpec: "", // 标红提示
      ruleFormImport: {
        jbDesc: "",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      importModal: false, // 导入弹窗
      fieldsModal: false, // 字段显示弹窗
      currentPage4: 1,
      searchForm: {
        content: "", // 内容
        word: "", // 敏感词
        type: "", // 类型
        nickname: "", // 昵称
        acount: "", // 账号
        campus: "", // 所属校区
        pubtime: "", // 发布时间
        status: "" //状态
      },
      checked: true,
      noticeModal: false, // 提示弹窗
      noticeType: 1, // 提示类型
      noitceContent: "是否确认删除？", // 提示信息
      noticeTitle: "确认操作", // 提示
      deleteRow: {}, // 单个删除行
      deleteList: [], // 多行删除
      keyIdList: [],
      type: "single",
      orderConfig: "", // 顺序设置
      tableDataShow: [], // 表格行设置
      tableRow: [
        {
          column: "公众号名称",
          key: "nickname",
          needKeyValue: true,
          caseKey: "nickname"
        },
        {
          column: "账号",
          key: "keyId",
          needKeyValue: false,
          caseKey: "keyId"
        },
        {
          column: "屏蔽类型",
          key: "actionType",
          needKeyValue: false,
          caseKey: "action_type",
          isCustomList: []
        },
        {
          column: "内容",
          key: "content",
          needKeyValue: false,
          caseKey: "content"
        },
        {
          column: "发布时间",
          key: "createTime",
          needKeyValue: false,
          caseKey: "createTime"
        },
        {
          column: "屏蔽原因",
          key: "shieldContent",
          needKeyValue: false,
          caseKey: "shieldContent"
        },
        {
          column: "屏蔽时间",
          key: "shieldTime",
          needKeyValue: false,
          caseKey: "shieldTime"
        },
        {
          column: "公众号管理员",
          key: "managerName",
          needKeyValue: true,
          caseKey: "managerName"
        },
        {
          column: "联系电话",
          key: "managerTel",
          needKeyValue: false,
          caseKey: "managerTel"
        },
      ],
      pageIndex: 1, //页码
      pageSize: 40, //每页条数
      total: 0, //数据总条数
      tableData: [], //表格数据
      leixin_select_data: [], //类型数据
      xiaoqu_select_data: [], //校区数据
      shieldManageInfo: {
        userType: 1,
        //筛选条件
        nickname: "", //昵称   数据库字段：pau.nickname
        keyId: "", //帐号        数据库字段：bu.account
        actionType: "", //类型        数据库字段：paa.action_type
        content: "", //内容        数据库字段：paa.content
        region: "", //校区        数据库字段：sci.campus_id
        createTime: "", //发布时间        数据库字段：paa.create_time
        createTimeStart: "", //发布时间开始    数据库字段：paa.create_time
        createTimeEnd: "", //发布时间结束    数据库字段：paa.create_time
        shieldContent: "", //屏蔽原因        数据库字段：paa.report_id
        shieldTime: "", //屏蔽时间        数据库字段：paa.shield_time
        shieldTimeStart: "", //屏蔽时间开始        数据库字段：paa.shield_time
        shieldTimeEnd: "" //屏蔽时间结束    数据库字段：paa.shield_time
      },
      val_data: [], //多选选中数组
      noticeModal_danshan: false, // 提示弹窗
      noticeType_danshan: 1, // 提示类型
      noitceContent_danshan: "是否确认解除屏蔽？", // 提示信息
      noticeTitle_danshan: "确认操作", // 提示
      noticeSpec_danshan: "", // 标红提示
      deletRow: "", //单行删除
      getselectdata: [],
      //-------
      hignModal: false, // 高级搜索
      hignSearchRes: "" // 高级检索条件
      //-----------------------------------------------------
    };
  },
  created () {
    const dispField = this.getSessonValue("ShieldingManagementChange");
    const tableRow = this.getSessonValue("ShieldingManagement");
    // console.log(dispField);
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      // console.log(tableRow);
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
  },
  mounted () {
    this.selectList();
    this.leixin_select();
    this.xiaoqu_select();
    this.getReportReasonList();
  },
  computed: {
    // ...mapState({
    //   tableRow: state => state.power.selectConfig.eduOtherUserInfo,
    //   userInfo: state => state.user.userInfo
    // })
  },
  methods: {
    changeCreateTime(value) {
      if(value === null) {
        this.shieldManageInfo.createTime = "";
        this.shieldManageInfo.createTimeStart = "";
        this.shieldManageInfo.createTimeEnd = "";
      }
    },
    changeShieldTime(value){
      if(value === null) {
        this.shieldManageInfo.shieldTime = "";
        this.shieldManageInfo.shieldTimeStart = "";
        this.shieldManageInfo.shieldTimeEnd = "";
      }
    },
    //获取举报原因列表
    getReportReasonList () {
      try {
        getReportReasonList().then(res => {
          const data = res.data;
          console.log("原来下拉列表", data);
          if (data.status === 1000) {
            this.getselectdata = data.result;
          } else {
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //点击详情
    details (row) {
      // this.$router.push({
      //   path: "/dynamicManage",
      //   query: { id: row.fatherId }
      // });
      console.log(row, '详情')
      this.$emit('toDetails', { id: row.userId, actionId: row.actionId, type: 1 });
    },
    //点击昵称
    clickFN (row) {
      // this.$router.push({ path: "/userManage", query: { id: row.userId } });
      // console.log("row.userID", row.userId);
      this.$emit('toDetails', { id: row.userId, actionId: '', type: 2 });
    },
    // 高级检索
    hignSearch () {
      this.hignModal = true;
    },
    // 高级检索
    toHignSearch (res) {
      // debugger
      console.log("？？？？？？？", res);
      this.hignSearchRes = res;
      this.pageIndex = 1;
      this.hignModal = false;
      this.selectList();
    },
    //解除屏蔽
    Relieve (row) {
      if (row == null) {
        if (this.val_data == "") {
          this.$message({
            type: "warning",
            message: "请选择数据"
          });
          return;
        }
        let show_data = [];
        this.val_data.forEach(item => {
          show_data.push(item.actionId);
        });
        this.deletRow = show_data.join();
      } else {
        this.deletRow = row.actionId;
        console.log(row);
      }
      this.noticeModal_danshan = true;
    },
    //确认解除屏蔽
    Relieve_FN () {
      try {
        const params = {
          id: this.deletRow, //动态及评论id
          type: 1 //0.屏蔽1.解除屏蔽
        };
        shield(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.selectList();
            this.$refs.ShieldingManagementIndex.clearSelection();
            this.noticeModal_danshan = false;
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          } else {
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //多选选中
    handleSelectionChange (val) {
      // console.log(val);
      this.val_data = val;
    },
    //保存选中状态
    getRowKey (row) {
      return row.actionId;
    },
    //获取类型
    leixin_select () {
      try {
        getActionTypeList().then(res => {
          const data = res.data;
          console.log("类型数据", data);
          if (data.status === 1000) {
            this.leixin_select_data = data.result;
            this.tableRow.forEach(element => {
              if (element.key === 'actionType') {
                element.isCustomList = this.leixin_select_data.map( (x) => {
                  return {
                    label: x.typeName,
                    value: x.id
                  }
                })
              }
            });
          } else {
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //获取校区
    xiaoqu_select () {
      try {
        selectCampusNameAndId().then(res => {
          const data = res.data;
          console.log("校区数据", data);
          if (data.status === 1000) {
            this.xiaoqu_select_data = data.result;
          } else {
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //获取列表
    selectList () {
      try {  
        const params = {
          //   shieldManageInfo: {
          //     //筛选条件
          //     nickname: "", //昵称   数据库字段：pau.nickname
          //     keyId: "", //帐号        数据库字段：bu.account
          //     actionType: "", //类型        数据库字段：paa.action_type
          //     content: "", //内容        数据库字段：paa.content
          //     region: "", //校区        数据库字段：sci.campus_id
          //     createTime: "", //发布时间        数据库字段：paa.create_time
          //     shieldContent: "", //屏蔽原因        数据库字段：paa.report_id
          //     shieldTime: "" //屏蔽时间        数据库字段：paa.shield_time
          //   },
          shieldManageInfo: this.shieldManageInfo,
          pageIndex: this.pageIndex, //页码
          pageSize: this.pageSize, //页面大小
          dataSortStr: this.orderConfig, //数据排序
          advancedSearch: this.hignSearchRes //高级检索
        };
        this.loading = true
        list(params).then(res => {
          this.loading = false
          const data = res.data;
          console.log("列表数据", data);
          if (data.status === 1000) {
            this.total = data.result.total;
            this.tableData = data.result.records;
          } else {
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询
    search () {
      console.log(this.shieldManageInfo);
      if (this.shieldManageInfo.createTime && Array.isArray(this.shieldManageInfo.createTime)) {
        this.shieldManageInfo.createTimeStart = this.shieldManageInfo.createTime[0];
        this.shieldManageInfo.createTimeEnd = this.shieldManageInfo.createTime[1];
      }
      if ( this.shieldManageInfo.shieldTime && Array.isArray(this.shieldManageInfo.shieldTime)) {
        this.shieldManageInfo.shieldTimeStart = this.shieldManageInfo.shieldTime[0];
        this.shieldManageInfo.shieldTimeEnd = this.shieldManageInfo.shieldTime[1];
      }
      this.hignSearchRes = "";
      this.selectList();
    },
    //重置
    Reset () {
      this.pageSize = 40;
      this.pageIndex = 1;
      this.shieldManageInfo.createTimeStart = "";
      this.shieldManageInfo.createTimeEnd = "";
      this.shieldManageInfo.shieldTimeStart = "";
      this.shieldManageInfo.shieldTimeEnd = "";
      this.hignSearchRes = "";
      this.orderConfig = "";
      this.$refs["shieldManageInfo"].resetFields();
      this.selectList();
    },
    //条数变化
    handleSizeChange (val) {
      this.pageIndex = 1
      this.pageSize = val;
      this.selectList();
    },
    //页码变化
    handleCurrentChange (val) {
      this.pageIndex = val;
      this.selectList();
    },
    //自动屏蔽策略
    ShieldingManagement () {
      this.$emit("ShieldingManagement", "");
    },
    //------------------------------------------
    // ShieldingManagement

    // 高级检索
    // toHignSearch(res) {
    //     this.hignSearchRes = res;
    //     this.hignModal = false;
    //     this.$refs.otherTable.search({
    //         pageIndex: 1,
    //         params: {
    //             advancedSearch: this.hignSearchRes,
    //             tenantId: this.userInfo.tenant_id
    //         }
    //     });
    // },
    // add() {
    //     this.$emit("changeComponent", "DetailsInfo");
    // },

    getSessonValue (name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
    getDataOrder (value) {
      this.orderConfig = value;
      this.search();
    },
    getTableList (value) {
      this.tableDataShow = value;
    },
    // 单个删除
    deleteSingleRow (row) {
      this.typ = "single";
      this.deleteRow = row;
      this.noticeModal = true;
    },
    // 多个删除
    deleteMultileRow () {
      if (!this.deleteList.length) {
        return this.$message.warning("请勾选需要删除的用户");
      }
      this.type = "multi";
      this.noticeModal = true;
    },
    async eduotheruserinfoRemove (params) {
      this.noticeModal = false;
      const {
        data: { msg, status }
      } = await eduotheruserinfoRemovePort(params);
      if (status === 1000) {
        this.$message.success("删除成功");
        this.$refs.otherTableBasic.clearSelection();
        if (this.typ === "single") {
          this.deleteRow = null;
        } else {
          this.deleteList = [];
          this.keyIdList = [];
        }
        return this.search();
      }
      this.$message.error(msg);
      return {};
    },
    cancel () {
      if (this.type === "single") {
        this.deleteRow = null;
      }
      this.noticeModal = false;
    },
    confirm () {
      if (this.type === "single") {
        console.log(this.deleteRow);
        return this.eduotheruserinfoRemove({
          ids: this.deleteRow.otherUserId,
          keyIds: this.deleteRow.keyId,
          tenantId: this.userInfo.tenant_id
        });
      }
      console.log("当前删除列表", this.deleteList);
      return this.eduotheruserinfoRemove({
        ids: this.deleteList.join(","),
        keyId: this.keyIdList.join(","),
        tenantId: this.userInfo.tenant_id
      });
    },

    changeComponent (rowData) {
      setStore({
        name: "rowData",
        content: rowData,
        type: "session"
      });
      this.$emit("changeComponent", "DetailsInfo");
    },
    // 导出数据
    outputData () {
      this.outputModal = true;
    },
    // 关闭导出
    closeOutPut () {
      this.outputModal = false;
    },
    // 关闭详情
    closeDetail () {
      this.detailModal = false;
    },
    // 确认弹窗
    agreeNotice () {
      this.noticeModal = false;
    },
    // 关闭弹窗
    closeNotice () {
      this.noticeModal = false;
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePreview (file) {
      console.log(file);
    },
    // 删除
    deleteItem () {
      this.noticeModal = true;
    },
    // 字段显示
    showFields () {
      this.fieldsModal = true;
      this.$nextTick(() => {
        this.initSortabel();
      });
    },
    // 保存字段
    addFields () {
      console.log(111);
    },
    // 关闭字段显示弹窗
    closeFileds () {
      this.fieldsModal = false;
    },
    // 显示高级或者不显示
    changeHign () {
      console.log(this.checked);
    },
    // 关闭弹窗
    closeModal () {
      this.hignModal = false;
    }
  }
};
</script>
<style lang="scss">
.others-manage_basic {
  .publicReport-btn-left {
    .sp {
      font-size: 12px;
      margin-right: 4px;
    }
  }
  .ShieldingManagementIndex {
    .el-table__body-wrapper {
      height: calc(100vh - 230px) !important;
    }
  }
}
</style>
